export const team = [
  { name: "Mubarak Ali", role: "Founder & CEO", image: "/assets/mubarak-owner.webp" },
  { name: "Raja Chaudhary", role: "Manager", image: "/assets/raja-manager.webp" },
  { name: "Nur Hoque Sarkar", role: "Audit & Account Assistant", image: "/assets/nur.webp" },
  { name: "Sirajul Islam", role: "Audit & Account Assistant", image: "/assets/sirajul-islam.webp" },
  { name: "Hemen Deka", role: "Audit & Account Assistant", image: "/assets/hemen-deka.webp" },
  { name: "Anjan Deka", role: "Audit & Account Assistant", image: "/assets/anjan-deka.webp" }
];
